
import Cookies from 'js-cookie';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Layout from '../../components/Layout/AdminLayout/AdminLayout';

import MembershipRegistryTable from '../../components/Table/MembersRegistry/MembersRegistryTable';
import SuccessModal from '../../components/Modal/SuccessModal';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import MessageModal from '../../components/Modal/MessageModal';

import searchIcon from '../../assets/search-interface-symbol.png';
import confirmIcon from '../../assets/warning-icon.png';
import warningIcon from '../../assets/warning-icon.png';

import { MembersRegistryTableData } from '../../interface/IMembersRegistry';
import helpers from '../../helpers/index';

import membersRegistryService from './membersRegistryService';
import { truncate } from 'fs';

function MembersRegistry() {

    const [membersRegistryTableData, setMembersRegistryTableData] = useState<MembersRegistryTableData[]>([]);
    const [showActiveOnly, setShowActiveOnly] = useState(true);
    const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
    const [selectedMemberId, setSelectedMemberId] = useState(0);
    const [message, setMessage] = useState('');
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [memberNameToDelete, setMemberNameToDelete] = useState("");
    const [modalMessageModalOpen, setModalMessageModalOpen] = useState(false);
    const [modalMessageText, setModalMessageText] = useState('');


    var dispatch = useDispatch();
    const navigate = useNavigate();

    function getPermission() {

        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }

    async function DeleteMemberButtonClick(memberId: number, name: string) {
        try {
            document.querySelector('.loader-container')?.classList.add('loader');

            setMemberNameToDelete(name);
            setSelectedMemberId(memberId);
            setIsOpenConfirmModal(true);

            setMessage(`Are you sure you want to delete ${name}?`);

        }
        catch (error) {
            console.log('DeleteAdminButtonClick:: ', error);


        }
        finally {

            document.querySelector('.loader-container')?.classList.remove('loader');
        }

    }


    function AddMemberButtonClick() {
        navigate('/Admin/CreateMember');

    }

    async function onYesButtonClick() {

        try {
            document.querySelector('.loader-container')?.classList.add('loader');

            setIsOpenConfirmModal(false);
            if (selectedMemberId) {
                await membersRegistryService.deleteMember(selectedMemberId);

                setResponseMessage(`${memberNameToDelete} Deleted Successfully!`);
                setModalOpen(true);

                await LoadMembersRegistry();
            }

        }
        catch (err) {

            setModalMessageText("Unable to delete memeber, there are related data on the system.");

            setModalMessageModalOpen(true);

        }
        finally {
            document.querySelector('.loader-container')?.classList.remove('loader');

        }

    }

    function onNoButtonClick() {
        setIsOpenConfirmModal(false);
    }

    function onClose() {
        setModalOpen(false);
    };

    function onCloseMessageModal() {
        setModalMessageModalOpen(false);
    }

    useEffect(function () {
        (async () => {

            document.querySelector('.loader-container')?.classList.add('loader');

            await LoadMembersRegistry();
            getPermission();
            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    async function LoadMembersRegistry() {

        try {
            var response = await membersRegistryService.listMembers();

            setMembersRegistryTableData(response.data.result);

        }
        catch (error) {

            console.log('LoadMembersRegistry error:: ', error);
        }

    }


    return (
        <Layout>
            <ConfirmModal icon={confirmIcon} message={message} buttonYesText='Delete' isOpen={isOpenConfirmModal} onYes={onYesButtonClick} onNo={onNoButtonClick} />
            <SuccessModal message={responseMessage} isOpen={isModalOpen} onClose={onClose} />
            <MessageModal icon={warningIcon} message={modalMessageText} isOpen={modalMessageModalOpen} onClose={onCloseMessageModal} />
            <div className="title-container">
                <div className="dv-title">

                    <h1>Members Panel</h1>

                </div>

                <div className="title-btn-container vertical-flex-bottom">

                    <button type="button" id="btnAddMember"
                        disabled={isReadOnly}
                        onClick={AddMemberButtonClick}
                        className="btn-green-1 center-middle">+ Add Member</button>

                </div>
            </div>
            <br />
            <div className="content-container">
                <div className="table-container">

                    <div>
                        <MembershipRegistryTable
                            data={showActiveOnly ? membersRegistryTableData.filter(m => m.isActive) : membersRegistryTableData}
                            deleteMemberButtonClick={DeleteMemberButtonClick}
                            isReadOnly={isReadOnly}
                            showActiveOnly={showActiveOnly}
                            onToggleActiveOnly={setShowActiveOnly} />
                    </div>
                </div>

            </div>
        </Layout>
    );

}



export default MembersRegistry;